import React from "react";
import Imagen from "../../images/modulo3/miescuela.png";
import LayoutActividad from "../../components/LayoutActividad";

import { modulo3 } from "../../routes/Module3";
import { modulo4 } from "../../routes/Module4";

import Sidebar from "./Sidebar";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo3/Cierre.mp3";

const Modulo1Conclusion = () => {
  const crumbs = [
    {
      title: modulo3.title,
      url: "/" + modulo3.url,
    },
    {
      title: `Cierre`,
      url: "cierre",
    },
  ];
  const pages = {
    titlePrev: `${modulo3.content[0].name} - ${modulo3.content[0].activities[7].name}`,
    linkPrev: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo3.color,
    title: `${modulo3.title}`,
    name: modulo3.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h1 className="my-5">Así es mi escuela</h1>
      <AudioPlayer track={Audio} />

      <p>Para terminar, pensemos…</p>
      <ul>
        <li>¿Qué hacen los personajes en la imagen?</li>
        <li>
          ¿Quiénes están ayudando a que la convivencia en la escuela sea
          positiva?
        </li>
        <li>¿Quiénes no están ayudando?</li>
        <li>¿Por qué es importante que todos colaboremos en la escuela?</li>
      </ul>

      <div className="header-img">
        <img src={Imagen} className="card-img-top full-width" alt="..." />
      </div>
      <GuiaDocente>
        <p>
          En la imagen vemos que algunos niños y niñas se comportan de manera
          que la convivencia entre todos sea mejor (ayudan, comparten, juegan).
          En otros casos, eso no ocurre. Finalice destacando la importancia de
          pensar siempre en el bienestar de todos.
        </p>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo4.url}>
          <button className={`btn btn-${modulo3.color} me-2`}>
            {modulo4.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Modulo1Conclusion;
